import "./header.scss";


const header = () => {

    let burger = document.getElementById('burger');
    let siteHeader = document.querySelector("header");
    let mobileMenu = document.getElementById('menu-mobile');
    let toggle = false;

    if(!burger && !mobileMenu && !siteHeader) return;

    const toggleClick = () => {
        let menuHeight = mobileMenu.querySelector('div[data-wrapper-height]').offsetHeight;
        if(!toggle && menuHeight) {
            siteHeader.classList.add('open');
            mobileMenu.classList.add('open');
            burger.classList.add('open');
            mobileMenu.style.height = menuHeight + 'px';
        } else {
            siteHeader.classList.remove('open');
            mobileMenu.classList.remove('open');
            burger.classList.remove('open');
            mobileMenu.style.height = '0px';
        }
        toggle = !toggle;
    }

    burger.addEventListener('click', (evt) => {
        evt.preventDefault();
        toggleClick();
    });

    addEventListener("scroll", (event) => {
        setTimeout(() => {
            if(toggle === true) {
                burger.click();
            }
        }, "1000")
    });


}

export default header;